import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {Body, H4} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {useIntl} from "@irati/utils/lang"

import {BILLING_TABS} from "../../../containers/Billing"

interface Props {}

const Welcome: FC<Props> = () => {
  const theme = useTheme()
  const {formatMessage} = useIntl()

  return (
    <Card marginBottom padding={2} bgColor={theme.colors.success}>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex gap={1} alignItems="center">
          <img src={formatMessage({id: "admin.components.yourPerkboxStory.welcome.img"})} height={32} width={32} />
          <H4 color={theme.colors.greys.white}>
            <FormattedMessage id="admin.components.yourPerkboxStory.welcome.title" />
          </H4>
          <Body small color={theme.colors.greys.white}>
            <FormattedMessage id="admin.components.yourPerkboxStory.welcome.body" />
          </Body>
        </Flex>
        <ButtonRouterLink inverted to={`/billing/${BILLING_TABS.CURRENT_PLAN}`}>
          <FormattedMessage id="admin.components.yourPerkboxStory.welcome.btn" />
        </ButtonRouterLink>
      </Flex>
    </Card>
  )
}

export default Welcome
